/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconZoomPan = createReactComponent("zoom-pan", "IconZoomPan", [
  ["path", { d: "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-0" }],
  ["path", { d: "M17 17l-2.5 -2.5", key: "svg-1" }],
  ["path", { d: "M10 5l2 -2l2 2", key: "svg-2" }],
  ["path", { d: "M19 10l2 2l-2 2", key: "svg-3" }],
  ["path", { d: "M5 10l-2 2l2 2", key: "svg-4" }],
  ["path", { d: "M10 19l2 2l2 -2", key: "svg-5" }]
]);

export { IconZoomPan as default };
//# sourceMappingURL=IconZoomPan.js.map
